import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ReactSwitch from "react-switch";
import { createContext } from "react";
import { FiMenu, FiX } from "react-icons/fi";
import { FaShoppingCart } from "react-icons/fa";

import logo from "../assets/images/logo.png";
import Notification from "./Notification/Notification";


export const ThemeContext = createContext(null);

const Navbar = (props) => {
  const jwt = localStorage.getItem("accessToken");
  const user = JSON.parse(localStorage.getItem("user"));
  
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prev) => !prev);
  };

  const toggleProfileMenu = () => {
    setIsProfileMenuOpen((prev) => !prev);
  };

  const handleLogout = () => {
    setIsConfirmDialogOpen(true);
  };

  const confirmLogout = () => {
    localStorage.removeItem("accessToken");
    setIsConfirmDialogOpen(false);
    navigate("/");
  };

  const cancelLogout = () => {
    setIsConfirmDialogOpen(false);
  };

  return (
    <header className="text-black-600 body-font">
      <div className="mx-auto flex flex-wrap p-5 items-center shadow-xl w-full md:justify-between">
        {/* Logo */}
        <a
          href="/"
          className="flex title-font font-medium items-center text-black-500"
        >
          <img src={logo} alt="logo" className="w-10 h-10 rounded-full" />
          <span className="text ml-3 text-xl">PPDDEH</span>
        </a>

        {/* Mobile Menu Icon */}
        <div className="ml-auto md:hidden">
          {isMobileMenuOpen ? (
            <FiX
              className="w-8 h-8 cursor-pointer text-white"
              onClick={toggleMobileMenu}
            />
          ) : (
            <FiMenu
              className="w-8 h-8 cursor-pointer text-white"
              onClick={toggleMobileMenu}
            />
          )}
        </div>

        {/* Navigation Links */}
        <nav
          className={`${
            isMobileMenuOpen ? "block" : "hidden"
          } absolute top-20 left-0 w-full md:static md:w-auto md:flex md:items-center md:justify-center md:space-x-10 md:bg-transparent bg-gray-800 z-50`}
        >
          <div className="flex flex-col md:flex-row md:ml-auto md:mr-auto items-center">
            <Link
              to="/"
              className={`mr-5 px-4 py-2 md:px-0 ${
                props.theme1 === "dark" ? "text-white" : "text-black"
              } hover:text-red-900`}
              onClick={toggleMobileMenu}
            >
              Home
            </Link>
            <Link
              to="/compiler"
              className={`mr-5 px-4 py-2 md:px-0 ${
                props.theme1 === "dark" ? "text-white" : "text-black"
              } hover:text-red-900`}
              onClick={toggleMobileMenu}
            >
              Compiler
            </Link>
            <Link
              to="/courses"
              className={`mr-5 px-4 py-2 md:px-0 ${
                props.theme1 === "dark" ? "text-white" : "text-black"
              } hover:text-red-900`}
              onClick={toggleMobileMenu}
            >
              Courses
            </Link>
            <Link
              to="/blog"
              className={`mr-5 px-4 py-2 md:px-0 ${
                props.theme1 === "dark" ? "text-white" : "text-black"
              } hover:text-red-900`}
              onClick={toggleMobileMenu}
            >
              Blog
            </Link>
            <Link
              to="/languages"
              className={`mr-5 px-4 py-2 md:px-0 ${
                props.theme1 === "dark" ? "text-white" : "text-black"
              } hover:text-red-900`}
              onClick={toggleMobileMenu}
            >
              Languages
            </Link>
            <Link
              to="/our-tools"
              className={`mr-5 px-4 py-2 md:px-0 ${
                props.theme1 === "dark" ? "text-white" : "text-black"
              } hover:text-red-900`}
              onClick={toggleMobileMenu}
            >
              Our Tools
            </Link>
            <Link
              to="/contact"
              className={`mr-5 px-4 py-2 md:px-0 ${
                props.theme1 === "dark" ? "text-white" : "text-black"
              } hover:text-red-900`}
              onClick={toggleMobileMenu}
            >
              Contact Me
            </Link>
            <Link
              to="/about"
              className={`mr-5 px-4 py-2 md:px-0 ${
                props.theme1 === "dark" ? "text-white" : "text-black"
              } hover:text-red-900`}
              onClick={toggleMobileMenu}
            >
              About Me
            </Link>

            <div className="block md:hidden lg:hidden">
              {jwt ? (
                <Link to="/profile" onClick={toggleMobileMenu}>
                  <button
                    className={`${
                      props.theme1 === "dark" ? "text-white" : "text-black"
                    }`}
                  >
                    Profile
                  </button>
                </Link>
              ) : (
                <Link to="/login-register">
                  <button
                    className={`${
                      props.theme1 === "dark" ? "text-white" : "text-black"
                    }`}
                  >
                    Login/Register
                  </button>
                </Link>
              )}
            </div>
          </div>

          <div className="flex items-center my-4 md:my-0 md:ml-4 space-x-4">
            <ReactSwitch
              onChange={props.toggleTheme1}
              checked={props.theme1 === "dark"}
            />
            <span
              className={`ml-2 text-sm ${
                props.theme1 === "dark" ? "text-white" : "text-black"
              }`}
            >
              {props.theme1 === "dark" ? "Dark Mode" : "Light Mode"}
            </span>

            <Link
              to="/cart"
              onClick={() => setIsMobileMenuOpen(false)}
              className="md:hidden"
            >
              <button className="login inline-flex items-center bg-gray-100 border-0 py-1 px-3 focus:outline-none hover:bg-gray-200 rounded text-base">
                <FaShoppingCart className="text-xl" />
              </button>
            </Link>
          </div>
        </nav>

        {/* Conditional rendering for Profile/Login and Cart Icon */}
        <div className="hidden md:block flex items-center space-x-4">
          {jwt ? (
            <div className="relative flex items-center gap-6">
              {/* notification */}
              <div className="text-lg text-black uppercase hover:text-red-600 dark:hover:text-purple-600 dark:text-white">
                <Notification />
              </div>

              <Link to="/cart">
                <button className="login inline-flex items-center hover:bg-gray-200 rounded text-base">
                  <FaShoppingCart className="text-xl" />
                </button>
              </Link>

              <button
                onClick={toggleProfileMenu}
                className="login inline-flex items-center bg-gray-100 border-0 py-1 px-3 focus:outline-none hover:bg-gray-200 rounded text-base"
              >
                {user.name}
              </button>

              {/* Profile Dropdown Menu */}
              {isProfileMenuOpen && (
                <div className="absolute right-0 mt-40 w-40 bg-white shadow-lg rounded-md z-50">
                  {/* Profile Button */}
                  <Link
                    to="/profile"
                    className="block px-4 py-2 text-black hover:bg-gray-200 hover:text-red-600 rounded-md"
                    onClick={() => setIsProfileMenuOpen(false)}
                  >
                    Profile
                  </Link>

                  {/* Logout Button */}
                  <button
                    onClick={handleLogout}
                    className="block w-full px-4 py-2 text-white bg-red-600 hover:bg-red-800 text-left rounded-md"
                  >
                    Logout
                  </button>
                </div>
              )}
            </div>
          ) : (
            <div className="relative flex items-center gap-4">
              {/* notification */}
              <div className="text-lg text-black uppercase hover:text-red-600 dark:hover:text-purple-600 dark:text-white">
                <Notification />
              </div>

              <Link to="/login-register">
                <button className="login inline-flex items-center bg-gray-100 border-0 py-1 px-3 focus:outline-none hover:bg-gray-200 rounded text-base">
                  Login/Register
                </button>
              </Link>
            </div>
          )}
        </div>
      </div>

      {/* Confirmation Dialog */}
      {isConfirmDialogOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-md shadow-lg w-96">
            <h3 className="text-lg font-semibold mb-4">
              Are you sure you want to log out?
            </h3>
            <div className="flex justify-between">
              <button
                onClick={cancelLogout}
                className="px-4 py-2 bg-gray-300 rounded-md hover:bg-gray-400"
              >
                Cancel
              </button>
              <button
                onClick={confirmLogout}
                className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
